import React from 'react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-163" data-mp="3kpugtgqsmnhi">
      <div className="mx-auto max-w-5xl" data-id="element-164" data-mp="3ksgwy4rr2bbc">
        <h2 className="text-center font-display text-[1.75rem] font-black leading-tight tracking-tight text-ink sm:text-[2.4rem]" data-id="element-165" data-mp="3fyvxs9ef7bak">
          Ce que disent les enseignants
        </h2>
        <p className="mt-3 text-center text-sm font-medium text-ink/70" data-id="element-166" data-mp="36ypq545el5jb">
          <span aria-hidden="true" data-id="element-167" data-mp="36wmo1lqz7ly8">⭐️⭐️⭐️⭐️⭐️</span> 4.9/5 · +2.000
          enseignants
        </p>

        <div className="mx-auto mt-10 grid max-w-4xl gap-5 sm:grid-cols-3" data-id="element-168" data-mp="32291m8uakp5p">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col rounded-2xl bg-sand p-6" data-id="element-169" data-mp="2s1ylafcyn1mb">
              <div className="text-sm text-amber-500" aria-label="5 étoiles sur 5" data-id="element-170" data-mp="v8difd5cpw86">
                <span aria-hidden="true" data-id="element-171" data-mp="q892ppc9p5j0">★ ★ ★ ★ ★</span>
              </div>
              <blockquote className="mt-4 flex-1 font-display text-sm italic leading-relaxed text-ink/85" data-id="element-172" data-mp="h555fnoyd5q8">
                &laquo;&nbsp;{item.quote}&nbsp;&raquo;
              </blockquote>
              <figcaption className="mt-6" data-id="element-173" data-mp="78tryudmm9u7">
                <p className="text-xs font-bold text-ink" data-id="element-174" data-mp="7a4z946a5zq2">{item.name}</p>
                <p className="text-xs text-ink/50" data-id="element-175" data-mp="c7deox01npnm">{item.location}</p>
              </figcaption>
            </figure>)}
        </div>

        <p className="mt-8 text-center text-[11px] text-ink/40" data-id="element-176" data-mp="14v9cy659hpmi">
          Témoignages illustratifs à titre de démonstration.
        </p>
      </div>
    </section>;
}